<app-page-selector
  [unitImage]="unitImage"
  [pages]="days"
  (emitSelection)="selectPage($event)"
></app-page-selector>

<div class="day-header">
  <h3>{{ titleHeader }}</h3>
</div>

<ng-container *ngFor="let block of blocks">
  <div class="block-wrapper">
    <app-block-viewer [block]="block"></app-block-viewer>
  </div>
</ng-container>
<div class="row">
  <button
    class="header-text add-button"
    mat-raised-button
    color="primary"
    (click)="goToPreviousPage()"
    [disabled]="isFirstPage()"
  >
    {{ 'Previous Page' | uppercase }}
  </button>
  <button
    class="header-text add-button"
    mat-raised-button
    color="primary"
    (click)="goToNextPage()"
    [disabled]="isLastPage()"
  >
    {{ 'Next Page' | uppercase }}
  </button>
</div>
